function App() {
  return (
    <div style={{ textAlign: "center", marginTop: "100px", fontSize: "2rem" }}>
      Hello World 🌍!
    </div>
  );
}

export default App;